import { LABEL_PREFIX } from './MenuFileButtons.constants';
export function resolveButtonLabel(fileName, label) {
  var finalFileName = fileName || label;
  return [LABEL_PREFIX, finalFileName].join(' ');
}